import React, { useState } from 'react';
import './styles.scss';

interface ChecklistItemData {
    id: number | string;
    title: string;
    checked: boolean;
    body: string;
    linkNotExternal?: string;
}

interface ChecklistItemProps {
    item: ChecklistItemData;
    onToggle: (id: number | string, checked: boolean) => void;
}

interface ChecklistProps {
    items: ChecklistItemData[];
    onToggle: (id: number | string, checked: boolean) => void;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ item, onToggle }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className='checklist-item'>
            <div className='checklist-item-head'>
                <div className='input-header-wrapper'>
                    <input type='checkbox' checked={item.checked} onChange={e => onToggle(item.id, e.target.checked)} />
                    <h4>{item.title}</h4>
                </div>
                {item.body && (
                    <div onClick={() => setIsOpen(!isOpen)}>
                        <svg className={`${isOpen ? 'open' : ''} icon-24`}>
                            <use xlinkHref='#as-chevron' />
                        </svg>
                    </div>
                )}
            </div>
            {isOpen && (
                <p className='body large'>
                    {item.body}
                    {item.linkNotExternal && (
                        <a href={item.linkNotExternal} target='_blank' rel='noopener noreferrer'>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-arrow-right' />
                            </svg>
                        </a>
                    )}
                </p>
            )}
        </div>
    );
};

const Checklist: React.FC<ChecklistProps> = ({ items, onToggle }) => (
    <div className='checklist'>
        {items.map(item => (
            <ChecklistItem key={item.id} item={item} onToggle={onToggle} />
        ))}
    </div>
);

export default Checklist;
